import { useQuery } from '@tanstack/react-query'
import { createClient } from '@/api/supabase'
import { USE_MOCK } from '@/config'

export interface UserSearchResult {
  id: string
  full_name: string
  phone: string
  role: string
  company_id: string | null
  is_active: boolean
}

export function useUserSearch(query: string) {
  const trimmed = query.trim()
  return useQuery({
    queryKey: ['user-search', trimmed],
    queryFn: async (): Promise<UserSearchResult[]> => {
      if (USE_MOCK || trimmed.length < 2) return []
      const supabase = createClient()
      const { data, error } = await supabase.rpc('search_users', {
        p_query: trimmed,
        p_limit: 20,
      })
      if (error) throw new Error(error.message)
      return (data ?? []) as UserSearchResult[]
    },
    enabled: trimmed.length >= 2,
    staleTime: 30_000,
  })
}
